import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_SURVEY_EVENTS,
  GET_SURVEY_EVENTS,
  SG_FETCH_SURVEY_EVENT,
  FETCH_SURVEY_EVENT,
  SG_ADD_SURVEY_EVENT,
  ADD_SURVEY_EVENT,
  SG_UPDATE_SURVEY_EVENT,
  UPDATE_SURVEY_EVENT,
  SG_DELETE_SURVEY_EVENT,
  DELETE_SURVEY_EVENT,
  SURVEY_EVENTS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getSurveyEvents(action) {
  try {
    yield put({ type: SURVEY_EVENTS_PENDING });
    const response = yield call(api.GET_SURVEY_EVENTS, action.payload);
    yield put({ type: GET_SURVEY_EVENTS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchSurveyEvent(action) {
  try {
    yield put({ type: SURVEY_EVENTS_PENDING });
    const response = yield call(api.FETCH_SURVEY_EVENT, action.payload);
    yield put({ type: FETCH_SURVEY_EVENT, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addSurveyEvent(action) {
  try {
    yield put({ type: SURVEY_EVENTS_PENDING });
    const response = yield call(api.ADD_SURVEY_EVENT, action.payload);
    yield put({ type: ADD_SURVEY_EVENT, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateSurveyEvent(action) {
  try {
    yield put({ type: SURVEY_EVENTS_PENDING });
    const response = yield call(api.UPDATE_SURVEY_EVENT, action.payload);
    yield put({ type: UPDATE_SURVEY_EVENT, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteSurveyEvent(action) {
  try {
    yield put({ type: SURVEY_EVENTS_PENDING });
    yield call(api.DELETE_SURVEY_EVENT, action.payload);
    yield put({ type: DELETE_SURVEY_EVENT, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* surveyEventsSaga() {
  yield takeLatest(SG_GET_SURVEY_EVENTS, getSurveyEvents);
  yield takeLatest(SG_FETCH_SURVEY_EVENT, fetchSurveyEvent);
  yield takeLatest(SG_ADD_SURVEY_EVENT, addSurveyEvent);
  yield takeLatest(SG_UPDATE_SURVEY_EVENT, updateSurveyEvent);
  yield takeLatest(SG_DELETE_SURVEY_EVENT, deleteSurveyEvent);
}